import { Component, Input, output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputType, SpecialCharacters } from 'src/app/core/enums';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../../../shared-constants';

@Component({
  selector: 'app-table-search-component',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.scss'],
  standalone: false,
})
export class TableSearchComponent {
  //Required Fields
  @Input({ required: true }) columnName!: string;
  @Input({ required: true }) control!: FormControl;

  //Optional Inputs
  @Input() allowedSpecialChars: SpecialCharacters =
    SpecialCharacters.ALPHABET_NUMBER;
  @Input() maxLength = 6;
  @Input() inputType = InputType.text;
  @Input() autoCapitalizeCharacters = true;
  @Input() placeholder = '';
  //Align header text left, otherwise align right
  @Input() rightAlign = false;

  //Outputs
  emitSearch = output<KeyboardEvent>();

  readonly IMAGE_SRC = IMAGE_SRC;
  readonly InputType = InputType;

  constructor(private readonly commonUtils: CommonUtils) {}

  search(event: KeyboardEvent): void {
    this.emitSearch.emit(event);
  }

  preventSpecialCharacters(event: KeyboardEvent): boolean {
    return this.commonUtils.preventSpecialCharacters(
      event,
      this.allowedSpecialChars,
    );
  }

  clearText() {
    this.control.setValue('');
    this.emitSearch.emit(this.control.value);
  }
}
